import mapActions from './mapActions';

export default mapActions('employee_trainings', {
    fetchAll_url: data => `/api/trainings/employee/${data.id}`
});
